module.exports = __webpack_public_path__ + "img/9d0453d.png";